import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ContactService } from './../../services/contact.service';
import { SoaImageService } from './../../services/soa-image.service';
import { ProfessionalService } from './../../services/professional.service';
import { UserService } from './../../services/user.service';
@Component({
  selector: 'app-add-professional',
  templateUrl: './add-professional.component.html',
  styleUrls: ['./add-professional.component.css']
})
export class AddProfessionalComponent implements OnInit {
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  submitForm: FormGroup;
  assign_fact: string;
  div1: boolean = true;
  div2: boolean = false;
  div3: boolean = true;
  isDisabled: boolean;

  professional_name: string;
  // contact_name: string;
  pro_unique_id: any;
  email: string;
  mobile_number: string;
  dob: string;
  ss_number: string;
  empl_type: string;
  address1: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  status: string;
  address2: string;
  customerfiltter: object = [];
  arrayOne(n: number): any[] {
    return Array(n);
  }
  n: number = 1;
  biiling_mode: boolean = false;
  biiling_read_only: boolean = false;
  btnDisable: boolean = false;
  submitted = false;
  pro_name_check = 'false';
  //contact_name_check = 'false';

  constructor(
    private _contact: ContactService,
    private _router: Router,
    private toastr: ToastrService,
    private formbuilder: FormBuilder,
    private _soaImage: SoaImageService,
    private _user: UserService,
    private _professional: ProfessionalService
  ) { }

  get dynamicFields() {
    return this.submitForm.controls["dynamicFields"] as FormArray;
  }

  ngOnInit() {
    this.user_id = localStorage.getItem('id'),
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.submitForm = this.formbuilder.group({
      APIKEY: this.APIKEY,
      user_id: [localStorage.getItem('id')],
      company_id: [localStorage.getItem('company_id')],
      professional_name: ['', Validators.required],
      pro_unique_id: ['', Validators.required],
      email: '',
      mobile_number: '',
      dob: this.dob,
      ss_number: '',
      empl_type: ['W-2', Validators.required],
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      status: 'Active',
      dynamicFields: this.formbuilder.array([]),
      mobile_invoice_id: [],
      item_row: [],
      checkbox_value: [],
      autoload_check: '',
    });
    const dynamicFieldForm = this.formbuilder.group({
      id: [0],
      Selected: [false],
      professional_customer_id: [''],
      customer_id: [''],
      speciality: [''],
      tax_exempt: [],
      work_type: ['Regular'],
      cost_rate: [''],
      markup: [''],
      sale_rate: [''],
      pro_item_status: ['Active'],
    });
    this.dynamicFields.push(dynamicFieldForm);

    this.addLine("yes");

    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }
    this._professional.customerprofessionalListFilter(customerModal)
      .subscribe(
        res => {
          this.customerfiltter = res.data;
        },
      )
  }

  addLine(checkk = 'yy') {
    var val = '';
    if (checkk == 'yes') {
      val = 'Overtime';
    } else {
      val = 'Regular';
    }
    const dynamicFieldForm = this.formbuilder.group({
      id: [''],
      Selected: [false],
      professional_customer_id: [''],
      customer_id: [''],
      speciality: [''],
      tax_exempt: [],
      work_type: [val],
      cost_rate: [''],
      markup: [''],
      sale_rate: [''],
      pro_item_status: ['Active'],
    });
    this.dynamicFields.push(dynamicFieldForm);
  }

  deleteRow(index: any) {
    var delBtn = confirm(" Do you want to delete ?");
    if (delBtn == true) {

      var sss = new Array();
      i = 0;
      this.submitForm.value.dynamicFields.forEach((element: { Selected: boolean; }) => {
        if (element.Selected == true) {
          sss.push(i);
        }
        i++;
      });
      for (var i = sss.length - 1; i >= 0; i--) {
        this.dynamicFields.removeAt(sss[i]);
      }
    }
  }

  checkProfessional() {
    var professional_name = this.submitForm.value.professional_name;
    var pro_unique_id = this.submitForm.value.pro_unique_id;
    if (professional_name != '') {
      const professionalModal = {
        APIKEY: this.APIKEY,
        user_id: this.user_id,
        company_id: this.company_id,
        professional_name: professional_name,
        pro_unique_id: pro_unique_id,
        professional_id: '',
      }

      this._professional.checkDuplicate_professional(professionalModal)
        .subscribe(
          res => {
            if (res.status == false) {
              alert(res.message);
              return false;
            } else {
              this.addprofessional();
            }
          },
        );
    }
    else {
      this.pro_name_check = 'true';
      document.getElementById("professional_name").focus();
    }

    if (pro_unique_id=='') {
      //this.contact_name_check = 'true';
      document.getElementById("pro_unique_id").focus();
    } 
  }

  //convenience getter for easy access to form fields
  get f() { 
    return this.submitForm.controls; 
  }

  addprofessional() {
    this.isDisabled = true;
    this.submitted = true;
    var price_alt = 0;

    // stop here if form is invalid
    if (this.submitForm.invalid) {
      return;
    }

    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);

    var len = 0;
    this.submitForm.value.dynamicFields.forEach((element: { 
      customer_id: any; speciality: any; markup: any; sale_rate: any; cost_rate: any; work_type: any; 
    }) => {
      var customer_id: any = (element.customer_id);
      var speciality: any = element.speciality;
      //var markup: any = element.markup;
      var sale_rate: any = element.sale_rate;
      var cost_rate: any = element.cost_rate;
      var work_type_item: any = element.work_type;

      if (work_type_item == 'Item') {
        if (customer_id == '' || speciality == '') {
          price_alt++;
        }
      } else {
        if (customer_id == '' || speciality == '' || sale_rate == '' || cost_rate == '' || sale_rate == 0 || cost_rate == 0) {
          price_alt++;
        }

        //added condition by deepak on 06/june/23
        //cost_rate multi by 1 because need to make cost_rate veriable to number datatype
        if(cost_rate*1 > sale_rate*1 || cost_rate*1 == sale_rate*1){ 
          price_alt++;
        } 
      }
      len++;
    });

    // added by archana-10/10/2022
    var alt = 0;
    for (var i = 0; i < len; i++) {
      var customer1 = $('#customer_id' + i).val();
      var speciality1 = $('#speciality' + i).val();
      var work_type1 = $('#work_type' + i).val();
      var cost_rate1: any = $('#cost_rate' + i).val();
      var sale_rate1: any = $('#sale_rate' + i).val();

      for (var jj = i + 1; jj < len; jj++) {
        var customer2 = $('#customer_id' + jj).val();
        var speciality2 = $('#speciality' + jj).val();
        var work_type2 = $('#work_type' + jj).val();
        //var cost_rate2 = $('#cost_rate' + jj).val();
        //var sale_rate2 = $('#sale_rate' + jj).val();

        if (customer1 == customer2 && speciality1 == speciality2 && work_type1 == work_type2) {
          alt++;
        }
      }

      var c1 = Number(cost_rate1); 
      var s1 = Number(sale_rate1);

      if (c1 != 0 && s1 != 0 && cost_rate1 != '' && sale_rate1 != '') {
        if (c1 > s1 && c1 != s1) {
          alt++;
        }
      }
    }

    if (alt != 0 || price_alt > 0 || len == 0) {
      alert('Please enter all fields valid or you can delete that row.Below are the rules defined-\n\n 1. The combination of customer,Speciality and Work type can not be empty.\n2. Cost Rate & Sale Rate can not be 0. \n3. Must have to enter atleast one row.\n4. Duplicate records are not allowed.\n5. Cost Rate should always be less than Sale Rate.');
      return false;
    }

    this._professional.addprofessionaldata(this.submitForm.getRawValue()).subscribe(
      (response) => {
        if (response && response['status'] == true) {
          this.toastr.success(response['data'], 'success!');
          this.isDisabled = false;
        }
        this._router.navigate(['/professional/professional-list/active']);

      }, err => {
        console.log(err);
      }
    );

  }

  //this is for Professional Information
  onlyAlpha_numberic(evt: { which: any; keyCode: any; }) {
    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46)
      return true;
    return false;
  }

  //this is for Main Address
  onlyAlpha_numberic_address(evt: { which: any; keyCode: any; }) {
    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    if ((ASCIICode >= 48 && ASCIICode <= 57) || (ASCIICode >= 65 && ASCIICode <= 90) || (ASCIICode >= 97 && ASCIICode <= 122) || ASCIICode == 38 || ASCIICode == 32 || ASCIICode == 39 || ASCIICode == 40 || ASCIICode == 41 || ASCIICode == 45 || ASCIICode == 44 || ASCIICode == 46 || ASCIICode == 35)
      return true;
    return false;
  }

  //this is for SS Number
  onlynumberprice(evt: { which: any; keyCode: any; }, fieldname: any) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode != 46 && charCode != 45 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  //this is for remove focus on Professional Name 
  removeFocusProname() {
    this.pro_name_check = 'false';
  }

  //this is for Markup input field
  priceachange(idd: string | number) {
    var markup: any = $("#markup" + idd).val();

    if (markup == '') {
      markup = 0;
    }

    var cost_rate: any = $("#cost_rate" + idd).val();
    if (cost_rate == '') {
      cost_rate = 0;
    }
    var princing_a1 = (((markup / 100) * cost_rate) + eval(cost_rate)).toFixed(2);
    var princing_a = princing_a1;

    var i = 0;
    this.submitForm.value.dynamicFields.forEach((element: { qty: string; price: string; sale_rate: any; }) => {
      var qty: any = parseFloat(element.qty) * 1;
      var price: any = parseFloat(element.price) * 1;
      if (i == idd) {
        element.sale_rate = princing_a;
      }
      i++;
    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
  }

  //this is for Sale Rate input field
  copy_pricing(idd: string | number) {
    var sale_rate: any = $("#sale_rate" + idd).val();
    var cost_rate: any = $("#cost_rate" + idd).val();

    var a_percent = sale_rate - cost_rate;
    if (a_percent == 0) {
      var final_a_percent = 0;
    }
    else if (a_percent < 0) {
      var final_a_percent = ((Math.abs(a_percent) / sale_rate) * 100);
    } else {
      var final_a_percent = ((Math.abs(a_percent) / sale_rate) * 100);
    }
    if (final_a_percent > 100)
      var f_a_per = final_a_percent - 100;
    else var f_a_per = final_a_percent;
    var result_a = Math.round(f_a_per * 100) / 100;
    var markup_percent: any = 0;
    var markup_percent1 = 0;
    if (cost_rate != 0)
      markup_percent1 = ((sale_rate - cost_rate) / cost_rate) * 100;
    markup_percent = markup_percent1.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    var i = 0;
    this.submitForm.value.dynamicFields.forEach((element: { qty: string; price: string; markup: number; }) => {
      var qty: any = parseFloat(element.qty) * 1;
      var price: any = parseFloat(element.price) * 1;
      if (i == idd) {
        element.markup = markup_percent * 1;
      }
      i++;
    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);

  }

  //this is for Cost Rate input field
  copy_pricing_change(idd: string | number) {
    var markup: any = $("#markup" + idd).val();
    var cost_rate: any = $("#cost_rate" + idd).val();
    var sale_rate: any = 0;
    var number = cost_rate.replace('$', '');
    cost_rate = number.replace(/,/g, '');

    if (cost_rate == '') {
      sale_rate = '';
    } else {
      var princing_a1: any = 0;
      princing_a1 = (((markup / 100) * cost_rate) + (cost_rate * 1)).toFixed(2);
      sale_rate = princing_a1;
    }

    $("#sale_rate" + idd).val(sale_rate);

    var i = 0;
    this.submitForm.value.dynamicFields.forEach((element: { qty: string; price: string; sale_rate: any; }) => {
      var qty: any = parseFloat(element.qty) * 1;
      var price: any = parseFloat(element.price) * 1;
      if (i == idd) {
        element.sale_rate = sale_rate;
      }
      i++;
    });
    this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    var a_percent = sale_rate - cost_rate;
    if (a_percent == 0)
      var final_a_percent = 0;
    else if (a_percent < 0)
      var final_a_percent = ((Math.abs(a_percent) / sale_rate) * 100);
    else
      var final_a_percent = ((Math.abs(a_percent) / sale_rate) * 100);
    if (final_a_percent > 100)
      var f_a_per = final_a_percent - 100;
    else var f_a_per = final_a_percent;
    var result_a = Math.round(f_a_per * 100) / 100;
  }

  copyprofessional_name(evt: any) {
    var professional_name: any = $("#professional_name").val();
    $("#pro_unique_id").val(professional_name);
    this.submitForm.get('pro_unique_id').setValue(professional_name);
  }

  copyrelationDataCustomer(index: any) {
    if (index == 0) {
      var cus_name: any = $("#customer_id0").val();
      this.submitForm.value.dynamicFields.forEach((element: { customer_id: any; }) => {
        element.customer_id = cus_name;
      });
      this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    }
  }

  copyrelationDataSpeciality(index: any) {
    if (index == 0) {
      var speciality: any = $("#speciality0").val();
      this.submitForm.value.dynamicFields.forEach((element: { speciality: any; }) => {
        element.speciality = speciality;
      });
      this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    }
  }

}

